import { computed, toRef } from 'vue';

const statusTones = ['success', 'warning', 'danger', 'secondary'];

/**
 * @param {unknown} value
 * @returns {Record<string, unknown>}
 */
function asRecord(value) {
  return value && typeof value === 'object' ? /** @type {Record<string, unknown>} */ (value) : {};
}

/**
 * @param {unknown} item
 * @returns {'success' | 'warning' | 'danger' | 'secondary'}
 */
function resolved_status_tone(item) {
  const normalizedItem = asRecord(item);
  const tone = String(normalizedItem.status_tone || '').trim().toLowerCase();
  if (statusTones.includes(tone)) {
    return /** @type {'success' | 'warning' | 'danger' | 'secondary'} */ (tone);
  }

  const status = String(normalizedItem.status || '').trim().toLowerCase();
  if (status.includes('pass') || status.includes('success') || status.includes('verified') || status.includes('complete')) {
    return 'success';
  }
  if (status.includes('fail') || status.includes('reject') || status.includes('error') || status.includes('mismatch')) {
    return 'danger';
  }
  if (status.includes('pending') || status.includes('open') || status.includes('review') || status.includes('running')) {
    return 'warning';
  }

  return 'secondary';
}

export default {
  name: 'HistoricalVerificationChecksView',
  emits: ['toggle-check'],
  props: {
    checks: { type: Array, default: () => [] },
    emptyMessage: { type: String, default: 'No verification checks were returned for this case.' },
    isExpanded: { type: Function, required: true },
    getCheckPassedChips: { type: Function, required: true },
    getCheckResultDetailRows: { type: Function, required: true },
    getCheckHistory: { type: Function, required: true },
    statusBadgeClass: { type: Function, required: true },
    evidenceIconClass: { type: Function, required: true },
    fieldResultRowClass: { type: Function, required: true }
  },
  setup(props) {
    const checks = toRef(props, 'checks');
    const normalized_checks = computed(() => (Array.isArray(checks.value) ? checks.value : []));
    const setup_api = {
      normalized_checks,
      resolvedStatusTone: resolved_status_tone
    };

    return setup_api;
  }
};
